import React from 'react';
import { createClient, Provider } from 'urql';

import { IMDB_CLIENT_NAME, IMDB_CLIENT_NAME_HEADER } from '../config/constants';
import { AppNavigator } from './components/AppNavigator/AppNavigator';

const graphqlClient = createClient({
    url: 'https://api.graphql.imdb.com/',
    fetchOptions: {
        headers: {
            [IMDB_CLIENT_NAME_HEADER]: IMDB_CLIENT_NAME
        }
    }
});

export const App = () => (
    <Provider value={graphqlClient}>
        <AppNavigator />
    </Provider>
);
